<template>
  <div>
    <router-link
      to="/admin/attendance/overtime/settings"
      class="move-right mt-20 pointer grid-full no-line"
    >
      <div class="settings-bg">
        <img src="/img/settings-b.svg" alt="settings" /> <span>Settings</span>
      </div>
    </router-link>
    <div class="white-bg mb-40">
      <div class="flex flex-v-center flex-h-bet">
        <h3 class="mt-0 bold header">Assign Employees to {{ titleText }}</h3>
        <div class="btn-wrapper mb-10  move-right">
          <button @click="$router.go(-1)" class="btn-back">
            <span>Back</span>
          </button>
        </div>
      </div>
      <AssignEmployee @updatePayload="updatePayload" :payload="payload" />
      <div class="btn-wrapper mt-20 sec-span">
        <el-button
          class="btn btn-blue no-border btn-full-radius inline-flex flex-v-end mr-15"
          @click.prevent="assign"
          :loading="loading"
          >Assign</el-button
        >
        <button class="btn-cancel mr-15" @click="$router.go(-1)">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
import AssignEmployee from "../../../../../components/general/AssignEmployee.vue";
export default {
  components: {
    AssignEmployee,
  },
  data() {
    return {
      titleText: "Approvers",
      loading: false,
      payload: {
        assignedEmployees: [],
        unAssignedEmployees: [],
        newlyAssigned: [],
        initiallyAssignedEmployees: [],
      },
    };
  },
  mounted() {
    const id = this.$route.params.id;
    this.fetchAssignableApprovals(id);
  },
  methods: {
    updatePayload(payload) {
      this.payload = payload;
    },
    fetchAssignableApprovals(id) {
      this.loading = true;
      this.$store
        .dispatch("admin/attendance/overtime/getAssignableApprovals", id)
        .then(response => {
          this.loading = false;
          const employees = response.data.employees;
          this.payload.assignedEmployees = [...employees];
          this.payload.initiallyAssignedEmployees = [...employees];
        })
        .catch(() => {
          this.loading = false;
        });
    },
    assign() {
      const id = this.$route.params.id;
      const { assignedEmployees, initiallyAssignedEmployees } = this.payload;
      const currentIds = assignedEmployees.map(e => e.id);
      const initialIds = initiallyAssignedEmployees.map(e => e.id);

      const assign_category_type_ids = currentIds.filter(
        id => !initialIds.includes(id)
      );
      const unassign_category_type_ids = initialIds.filter(
        id => !currentIds.includes(id)
      );

      if (
        !assign_category_type_ids.length &&
        !unassign_category_type_ids.length
      ) {
        return this.$notification.error("Kindly select or deselect employees");
      }
      this.loading = true;

      this.$store
        .dispatch("admin/attendance/overtime/assignEmployeeToApproval", {
          data: {
            category_type: "employee",
            assign_category_type_ids,
            unassign_category_type_ids,
          },
          id,
        })
        .then(() => {
          this.loading = false;
          this.$router.push("/admin/attendance/overtime/settings/approver");
        })
        .catch(error => {
          this.$notification.error(error.message);
          this.loading = false;
        });
    },
  },
};
</script>
